module.exports = __WEBPACK_EXTERNAL_MODULE__mui_icons_material_ExpandMore__;